<script lang="ts">
    import { Button,Modal,ModalHeader,ModalBody,ModalFooter} from "sveltestrap";
    import data from "../../../../Data/ComponentData/Ui-kits/Modal/Modal.json"
    import { Close, Modaltitle, Savechanges, Scrollinglongcontent } from "../../../../utils/Constant/Constant";
    let open: boolean = false;
    const toggle = () => (open = !open);
</script>

<Button color="primary" on:click={toggle}>{Scrollinglongcontent}</Button>
<Modal isOpen={open} {toggle}>
    <ModalHeader {toggle}>
        {Modaltitle}
        <Button class="btn-close" aria-label="Close" />
    </ModalHeader>
    <ModalBody>
        {#each data.Basicmodaldata as modalItem}
            <p>{modalItem.discription} </p>
        {/each}
    </ModalBody>
    <ModalFooter>
        <Button color="secondary" on:click={toggle}>{Close}</Button>
        <Button color="primary" on:click={toggle}>{Savechanges}</Button>
    </ModalFooter>
</Modal>
